// [NEW FILE] Switches for the backend changes that are being built for the new requirements (PM points).
//
// Each switch is false by default: the frontend then uses its own workaround, which works with today's backend.
// When the backend person delivers a change, set its switch to true in .env and rebuild; nothing else is needed.
// The exact request/response shapes are in BACKEND_CONTRACT_PM.md.
const on = (name) => String(process.env[name] || "false").trim().toLowerCase() === "true";

export const BACKEND = {
  // PM-10: the backend sends reminders by itself every day (scheduler). The browser stops calling POST /reminders/dispatch.
  reminderScheduler: on("REACT_APP_BACKEND_REMINDER_SCHEDULER"),
  // PM-13 and PM-9: rating schemes carry scale ("0_5" | "1_10") and pip_rule ({ enabled, lowest_band_count }) (migration 016).
  ratingScaleField: on("REACT_APP_BACKEND_RATING_SCALE"),
  // PM-9: the backend creates the PIP draft itself when HR finalises a rating. The browser stops creating it.
  pipAuto: on("REACT_APP_BACKEND_PIP_AUTO"),
  // PM-15 and PM-17: the reviewing manager (goal approval) and HR (KRA, KPI & goal review) may edit an employee's goals.
  reviewerGoalEdit: on("REACT_APP_BACKEND_REVIEWER_GOAL_EDIT"),
  // PM-4: performance cycles can be imported through /import-batches with import_type PERFORMANCE_CYCLE.
  cycleImport: on("REACT_APP_BACKEND_CYCLE_IMPORT"),
  // PM-4: the dates of a running cycle can be changed with one call (PATCH /performance-cycles/{id}/dates).
  activeCycleDates: on("REACT_APP_BACKEND_ACTIVE_CYCLE_DATES"),
  // PM-8: GET /audit-logs/me returns the signed-in user's own audit trail (any role).
  myAuditLog: on("REACT_APP_BACKEND_MY_AUDIT_LOG"),
};
